import React, { useState, useEffect } from "react";
// import "./ActivityLog.css";
import "../../GlobalCss/SPF/ActivityLog.css";
import { Layout, Select, DatePicker, Table, Spin, message, Card,Button } from "antd";
import { BaseUrl, JsonConfig } from "../../Repository/BaseRepository";
import Cookies from "js-cookie";
import { Redirect, Link } from "react-router-dom";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import { ErrorMessage, SuccessMessage, InfoMessage, routes } from "../../Utils/Utils";
import axios from 'axios';
const { Header, Content } = Layout;
const { RangePicker } = DatePicker;
import { useTenantStyle } from "../../Utils/Utils";


const minDate = new Date();
const maxDate = new Date();
minDate.setDate(minDate.getDate() - 14)
maxDate.setDate(maxDate.getDate() + 1)

const ActivityLog = () => {
    const [activitiesList, setActivitiesList] = useState([]);
    const [usersList, setUsersList] = useState([])
    const [selectedActivity, setSelectedActivity] = useState("Select Activity")
    const [selectuser, setSelectedUser] = useState("Select User")
    const [logData, setLogData] = useState([]);
    const [spin, setSpin] = useState(false)
    const [actGetSpin, setActGetSpin] = useState(false)
    const [userGetSpin, setUserGetSpin] = useState(false)
    const [fromDate, setFromDate] = useState()
    const [toDate, setTodate] = useState()
    const [newFrom, setNewFrom] = useState("")
    const [newTo, setNewTo] = useState("")
    const [primaryActivity, setPrimaryActivity] = useState([]);
    const jwtToken = Cookies.get("jwt_token");
    const tenantName = Cookies.get("tenant_name");
    useEffect(() => {
        callAllActivities();
    }, []);
    const changeFromDate = (e) => {
        setActivitiesList([])
        activitiesList.length = 0
        setUsersList([])
        usersList.length = 0
        setSelectedActivity("Select Activity")
        setSelectedUser("Select User")
        logData.length = 0
        setLogData([])
        let sample = new Date(e)
        if (e !== null) {
            setFromDate(sample)
        }
        else {
            setFromDate()
        }
        var newD = parseInt(sample.getFullYear()) + '-' + parseInt(sample.getMonth() + 1) + '-' + parseInt(sample.getDate());
        setNewFrom(newD)
        if (toDate !== undefined && sample < toDate && e !== null) {
            callActivitiesList(newD, newTo)
        }
        else if (toDate !== undefined && sample > toDate && e !== null) {
            InfoMessage("From date should not be greater than To date")
        }
    }
    const changeToDate = (e) => {
        setActivitiesList([])
        activitiesList.length = 0
        setUsersList([])
        usersList.length = 0
        setSelectedActivity("Select Activity")
        setSelectedUser("Select User")
        logData.length = 0
        setLogData([])
        let sample = new Date(e)
        if (e !== null) {
            setTodate(sample)
        }
        else {
            setTodate()
        }
        var newD = parseInt(sample.getFullYear()) + '-' + parseInt(sample.getMonth() + 1) + '-' + parseInt(sample.getDate());
        setNewTo(newD)
        if (fromDate !== undefined && fromDate < sample && e !== null) {
            callActivitiesList(newFrom, newD)
        }
        else if (fromDate !== undefined && fromDate > sample && e !== null) {
            InfoMessage("To date should be greater than From date")
        }
    }
    const callActivitiesList = async (from, to) => {
        try {
            setActGetSpin(true)
            let url = `${BaseUrl}Auditlog/GetActivities?startDate=${from}&endDate=${to}`
            const response = await axios.get(url, JsonConfig);
            const temp = JSON.parse(response.data.payload)
            if (response.data.statusCode === 500) {
                setActGetSpin(false)
            }
            else if (response.data.statusCode === 200) {
                setActivitiesList(temp)
                setActGetSpin(false)
            }
            else {
                setActGetSpin(false)
                ErrorMessage("Cannot able to get data, please try again !!")
            }
        }
        catch {
            setActGetSpin(false)
            ErrorMessage("Cannot able to get data, please try again !!")
        }
    }
    const callUsersAPi = async (prop) => {
        try {
            setSelectedUser("Select User")
            logData.length = 0
            setLogData([])
            setUserGetSpin(true)
            setSelectedActivity(prop)
            setUsersList([])
            usersList.length = 0
            let url = `${BaseUrl}Auditlog/GetUsers?activity=${prop}&startDate=${newFrom}&endDate=${newTo}`;
            const response = await axios.get(url, JsonConfig)
            const temp = JSON.parse(response.data.payload)
            const loopedList = []
            if (response.data.statusCode === 500) {
                setUserGetSpin(false)
            }
            else if (response.data.statusCode === 200) {
                temp.forEach(element => {
                    const email = element.split('@')[0].replace('.', " ").replace(/[0-9]/g, "")
                    const words = email.split(' ');
                    const formattedEmail = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                    loopedList.push({
                        "name": element,
                        "value": formattedEmail
                    })
                });
                setUsersList([...loopedList]);
                setUserGetSpin(false)
            }
            else {
                setUserGetSpin(false)
                ErrorMessage("Cannot able to get data, please try again !!")
            }
        }
        catch {
            setUserGetSpin(false)
            setSelectedUser("Select User")
            logData.length = 0
            setLogData([])
            setUsersList([])
            usersList.length = 0
            ErrorMessage("Cannot able to get data, please try again !!")
        }
    }
    const callLogApi = async (prop) => {
        try {
            setSpin(true)
            setSelectedUser(prop)
            logData.length = 0
            setLogData([])
            let url = `${BaseUrl}Auditlog/Getactivitylog?startDate=${newFrom}&endDate=${newTo}&uname=${prop}&activity=${selectedActivity}`;
            const response = await axios.get(url, JsonConfig)
            const temp = JSON.parse(response.data.payload)
            const loopedList = []
            if (response.data.statusCode === 500) {
                setSpin(false)
            }
            else if (response.data.statusCode === 200) {
                temp.forEach(element => {
                    const email = element.user_Id.split('@')[0].replace('.', " ").replace(/[0-9]/g, "")
                    const words = email.split(' ');
                    const formattedEmail = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
                    const sample = new Date(element.Created_Date);
                    var formattedTime = parseInt(sample.getMonth() + 1) + '-' + parseInt(sample.getDate()) + '-' + parseInt(sample.getFullYear()) +
                        " " + sample.getHours() + ":" + sample.getMinutes() + ":" + sample.getSeconds();
                    loopedList.push({
                        "activity": selectedActivity,
                        "user_Id": element.user_Id,
                        "name": formattedEmail,
                        "created_Date": formattedTime,
                        "newValue": element.NewValue,
                        "oldValue": element.OldValue,
                    })
                });
                setLogData([...loopedList]);
                setSpin(false)
            }
            else {
                setSpin(false)
                ErrorMessage("Cannot able to get data, please try again !!")
            }
        }
        catch {
            setSpin(false)
            ErrorMessage("Cannot able to get data, please try again !!")
        }
    }
    const columns = [
        { title: 'Activity', dataIndex: 'activity', key: 'activity', width: 250 },
        { title: 'Time', dataIndex: 'created_Date', key: 'created_Date', width: 150 },
        { title: 'Old value', dataIndex: 'oldValue', key: 'oldValue', width: 100 },
        { title: 'New value', dataIndex: 'newValue', key: 'newValue', width: 100 },
        { title: 'Username', dataIndex: 'name', key: 'name', },
        { title: 'User Email', dataIndex: 'user_Id', key: 'user_Id' },
    ]
    const filterOption = (input, option) => {
        return (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
    }

    const callAllActivities = async () => {
        try {
            let url = `${BaseUrl}Auditlog/GetCountOfActivities`;
            const response = await axios.get(url, JsonConfig);
            const temp = JSON.parse(response.data.payload);
            if (response.data.statusCode === 200) {
                setPrimaryActivity(temp);
            } else {
                ErrorMessage("Cannot able to get data, please try again !!");
            }
        }
        catch {
            ErrorMessage("Cannot able to get data, please try again !!");
        }
    }
    
    return (<>

        <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
            <SideNavBar />
            <Layout style={{ backgroundColor: "white" }}>
                <Header className="activity-header-class"><Navbar /></Header>
                <Content className="activitylog-content">
                <div className="expensepages">
                   <Link to={`/${tenantName}/utilities`}><Button className="page-button">Utilities</Button></Link>
                   <Link to={`/${tenantName}/activitylog`}><Button className="currentpreview-button">Activity Log</Button></Link>
                <Link to={`/${tenantName}/analytics`}><Button className="page-button">Analytics (File Upload)</Button></Link>
                <Link to={`/${tenantName}/Analytics 2`}><Button className="page-button">Analytics</Button></Link>

            

              </div>

                    <div className="activity-log-heading"><p className="heading-activity">Activity Log</p>
                    </div>
                    <Content>
                        <h3 style={{ marginLeft: "60px", color: "#002766" }}>Last 30 days Activities Count:</h3>
                        <div className="activity_count_content">
                            {Object.entries(primaryActivity).map(([category, count]) => (
                                <Card
                                    key={category}
                                    title={<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: "#002766" }}>{category}<span style={{ fontWeight: 'bold' }}>{count}</span></div>}
                                    bordered={true}
                                    style={{
                                        height: "55px", width: 190, marginRight: 8, marginBottom: 16, color: '#C4C4C4', borderRadius: "10px", borderColor: "#0050B3",
                                    }}
                                >
                                    {/* Content if needed */}
                                </Card>
                            ))}
                        </div>
                    </Content>
                
                    <div className="activity-selector">
                        <div className="selector-row">
                            <div className="from-class">

                                <DatePicker onChange={changeFromDate} placeholder="From Date" format={"MM-DD-YYYY"}
                                    disabledDate={(current) => current && (current < minDate || current > maxDate)} />
                            </div>
                            <div className="activity-spinner">{actGetSpin ? <Spin size="medium" /> : null}</div>

                            <div className="today-class">
                                <DatePicker onChange={changeToDate} loading={actGetSpin} placeholder="To Date" format={"MM-DD-YYYY"}
                                    disabledDate={(current) => current && (current < minDate || current > maxDate)} />
                            </div>

                            <div className="act-select-class">
                                <Select placeholder="Select Activity" value={selectedActivity} onSelect={(value) => { callUsersAPi(value) }} className="dropdown-select"
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={filterOption}>
                                    {
                                        activitiesList ? activitiesList.map((item, index) => {
                                            return (
                                                <Select.Option key={item}>{item}</Select.Option>)
                                        }) : null
                                    }
                                </Select>
                                <div className="xl-spinner">
                                    {userGetSpin ? <Spin size="medium" /> : null}</div>
                            </div>

                            <div className="user-select-class">
                                <Select placeholder="Select User" value={selectuser} onSelect={(value) => { callLogApi(value) }} className="dropdown-select"
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={filterOption}>
                                    {
                                        usersList ? usersList.map((item, index) => {
                                            return (
                                                <Select.Option key={item.name}>{item.value}</Select.Option>)
                                        }) : null
                                    }
                                </Select>
                            </div>
                        </div>
                    </div>
                    <div className="note-class">
                        <div className="note-showing-class">
                            <p className="note-heading">Note : To get more than 15 days logs details, please send a mail to <span className="mailname-class">payroll@spectraforce.com</span></p>
                        </div>
                    </div>
                    <div className="activities-showing">
                        <div className="table-activity-class">
                            {spin ? <Spin tip="">
                                <Table className="activitylog-table" columns={columns}
                                    scroll={{ x: "max-content" }} dataSource={logData}
                                    bordered />
                            </Spin> : logData.length > 0 ?
                                <Table className="activitylog-table" columns={columns}
                                    scroll={{ x: "max-content", y: 350 }} dataSource={logData}
                                    bordered /> :
                                <Table className="activitylog-table" columns={columns}
                                    scroll={{ x: "max-content" }} dataSource={logData}
                                    bordered />}
                        </div>
                    </div>


                </Content>
            </Layout>
        </Layout>
    </>)
}

export default ActivityLog;